var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopBarricade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 80,
    viewBox: "0 0 87 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.195 8.50301H13.292V79.151H19.195V8.50301Z",
    fill: "#683A4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.707 8.50301H67.805V79.151H73.707V8.50301Z",
    fill: "#683A4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.193 34.95H13.292V36.924H19.193V34.95Z",
    fill: "#512A3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.707 34.95H67.806V36.924H73.707V34.95Z",
    fill: "#512A3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.193 53.657H13.292V55.632H19.193V53.657Z",
    fill: "#512A3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.707 53.657H67.806V55.632H73.707V53.657Z",
    fill: "#512A3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.972 14.597V26.937L13.312 14.597H0.972Z",
    fill: "#FF9A15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.312 14.597L0.972 26.937V34.95H11.647L32 14.597H13.312Z",
    fill: "#FFEAA8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14.597L11.647 34.95H23.988L44.341 14.597H32Z",
    fill: "#FF9A15"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.029 14.597H44.341L23.988 34.95H42.676L63.029 14.597Z",
    fill: "#FFEAA8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.017 34.95L75.37 14.597H63.029L42.676 34.95H55.017Z",
    fill: "#FF9A15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 34.95L86.028 22.628V14.597H75.37L55.017 34.95H73.705Z",
    fill: "#FFEAA8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.028 34.95V22.628L73.705 34.95H86.028Z",
    fill: "#FF9A15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 34.95H86.028V32.156H76.499L73.705 34.95Z",
    fill: "#EF772B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.811 32.156L55.017 34.95H73.705L76.499 32.156H57.811Z",
    fill: "#FFDA60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.47 32.156L42.676 34.95H55.017L57.811 32.156H45.47Z",
    fill: "#EF772B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.782 32.156L23.988 34.95H42.676L45.47 32.156H26.782Z",
    fill: "#FFDA60"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.441 32.156L11.647 34.95H23.988L26.782 32.156H14.441Z",
    fill: "#EF772B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76601 32.156V24.143L0.972 26.937V34.95H11.647L14.441 32.156H3.76601Z",
    fill: "#FFDA60"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76601 14.597H0.972V26.937L3.76601 24.143V14.597Z",
    fill: "#EF772B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.972 45.625V53.657H5.28099L13.313 45.625H0.972Z",
    fill: "#FF9A15"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.313 45.625L5.28099 53.657H23.97L32.001 45.625H13.313Z",
    fill: "#FFEAA8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.001 45.625L23.97 53.657H36.31L44.342 45.625H32.001Z",
    fill: "#FF9A15"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.342 45.625L36.31 53.657H54.999L63.03 45.625H44.342Z",
    fill: "#FFEAA8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.999 53.657H67.34L75.371 45.625H63.03L54.999 53.657Z",
    fill: "#FF9A15"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.028 53.657V45.625H75.371L67.34 53.657H86.028Z",
    fill: "#FFEAA8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.34 53.657H86.028V50.863H70.134L67.34 53.657Z",
    fill: "#FFDA60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.793 50.863L54.999 53.657H67.34L70.134 50.863H57.793Z",
    fill: "#EF772B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.105 50.863L36.31 53.657H54.999L57.793 50.863H39.105Z",
    fill: "#FFDA60"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.764 50.863L23.97 53.657H36.31L39.105 50.863H26.764Z",
    fill: "#EF772B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.076 50.863L5.28099 53.657H23.97L26.764 50.863H8.076Z",
    fill: "#FFDA60"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76601 50.863V45.625H0.972V53.657H5.28099L8.076 50.863H3.76601Z",
    fill: "#EF772B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.363 5.66C10.363 2.534 12.897 0 16.023 0C19.149 0 21.683 2.534 21.683 5.66C21.683 8.786 19.149 11.32 16.023 11.32C12.897 11.32 10.363 8.786 10.363 5.66Z",
    fill: "#FFDA60"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.84 8.36301C16.4571 8.36301 17.768 7.05209 17.768 5.435C17.768 3.81791 16.4571 2.507 14.84 2.507C13.2229 2.507 11.912 3.81791 11.912 5.435C11.912 7.05209 13.2229 8.36301 14.84 8.36301Z",
    fill: "#FFEAA8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.767 2.507C17.767 2.053 18.135 1.685 18.589 1.685C19.043 1.685 19.411 2.053 19.411 2.507C19.411 2.961 19.043 3.32901 18.589 3.32901C18.135 3.32901 17.767 2.961 17.767 2.507Z",
    fill: "#FFEAA8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.097 5.66C65.097 2.534 67.631 0 70.757 0C73.883 0 76.417 2.534 76.417 5.66C76.417 8.786 73.883 11.32 70.757 11.32C67.631 11.32 65.097 8.786 65.097 5.66Z",
    fill: "#FFDA60"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.574 8.36301C71.1911 8.36301 72.502 7.05209 72.502 5.435C72.502 3.81791 71.1911 2.507 69.574 2.507C67.9569 2.507 66.646 3.81791 66.646 5.435C66.646 7.05209 67.9569 8.36301 69.574 8.36301Z",
    fill: "#FFEAA8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.501 2.507C72.501 2.053 72.869 1.685 73.323 1.685C73.777 1.685 74.145 2.053 74.145 2.507C74.145 2.961 73.777 3.32901 73.323 3.32901C72.869 3.32901 72.501 2.961 72.501 2.507Z",
    fill: "#FFEAA8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.019 75.764H9.468C7.681 75.764 6.23299 77.212 6.23299 78.999V79.151H26.254V78.999C26.254 77.212 24.806 75.764 23.019 75.764Z",
    fill: "#683A4F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.244 75.764H9.62001C7.74901 75.764 6.23299 77.281 6.23299 79.151H16.244V75.764Z",
    fill: "#512A3B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.532 75.764H63.981C62.194 75.764 60.746 77.212 60.746 78.999V79.151H80.767V78.999C80.767 77.212 79.319 75.764 77.532 75.764Z",
    fill: "#683A4F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M70.756 75.764H64.133C62.262 75.764 60.746 77.281 60.746 79.151H70.757V75.764H70.756Z",
    fill: "#512A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBarricade);
export default __webpack_public_path__ + "static/media/stop-barricade.a5350b5d18e9cf98283ffeca6c9c1cb5.svg";
export { ForwardRef as ReactComponent };